import { defineStore } from 'pinia'
import { TokenService } from '@/services/token.service.ts'
import type { Menubar, User, Notification, Breadcrumb, PageItem } from '@/types/model'
import type { ThemeKey } from '@/types'

export const useAppStore = defineStore('app', {
  state: () => ({
    theme: 'light' as ThemeKey,
    isLogin: !!TokenService.getToken(),
    user: null as User | null,
    hideBackground: false as boolean,
    menubar: null as Menubar[] | null,
    notification: null as Notification | null,
    breadcrumbs: null as Breadcrumb[] | null,
    sidebar: null as PageItem[] | null,
    loaded: false as boolean,
  }),

  actions: {
    initTheme() {
      const isNotHaveTheme = !localStorage.getItem('theme')
      const isSystemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      const isThemeDark = localStorage.getItem('theme') && localStorage.getItem('theme') === 'dark'

      // Atur tema berdasarkan `localStorage` atau preferensi sistem
      if (isThemeDark || (isNotHaveTheme && isSystemDark)) {
        this.theme = 'dark'
        document.documentElement.classList.add('dark')
        localStorage.setItem('theme', 'dark')
      } else {
        this.theme = 'light'
        document.documentElement.classList.remove('dark')
        localStorage.setItem('theme', 'light')
      }
    },
    toggleTheme() {
      this.theme = this.isDarkMode ? 'light' : 'dark'
      document.documentElement.classList.toggle('dark', this.isDarkMode)
      localStorage.setItem('theme', this.theme)
    },
    loginGoogle() {
      window.location.href =
        'https://erwinzilla.com/api/auth/google/redirect?redirect_uri=https://pts.erwinzilla.com/google/callback'
    },
    setLogin(status: boolean) {
      this.isLogin = status
    },
    setUser(user: User | null | undefined) {
      this.user = user ?? null
    },
    setMenubar(menubar: Menubar[] | null | undefined) {
      this.menubar = menubar ?? null
    },
    setNotification(notification: Notification) {
      this.notification = notification
    },
    setBreadcrumb(breadcrumbs: Breadcrumb[] | null | undefined) {
      this.breadcrumbs = breadcrumbs ?? null
    },
    setHideBackground(val: boolean) {
      this.hideBackground = val
    },
    setSidebar(sidebar: PageItem[] | null | undefined) {
      this.sidebar = sidebar ?? null
    },
    setLoaded(loaded: boolean) {
      this.loaded = loaded
    },
  },
  getters: {
    isDarkMode: (state) => state.theme === 'dark',
  },
})
